export const InstrumentoFields = {
    CodOperacionLimiteTipo: 'codOperacionLimiteTipo',
    Excepcion: 'excepcion',
    ValorNominal: 'valorNominal',
    CashValueUSD: 'cashValueUSD',
    Instrumento: 'instrumento',
    DescOperacionLimiteTipo: 'descOperacionWRMLimiteTipo'
} as const

export const InstrumentoPutFields = {
    CodOperacionLimiteTipo: 'codOperacionLimiteTipo',
    Excepcion: 'excepcion',
    ValorNominal: 'valorNominal',
    CashValueUSD: 'cashValueUSD',
    Instrumento: 'instrumento'
} as const
